import { render, staticRenderFns } from "./StaticPage.vue?vue&type=template&id=551cf477&"
import script from "./StaticPage.vue?vue&type=script&lang=js&"
export * from "./StaticPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports